import { useQuery } from "react-query";
import { ConsentsApi } from "../../services";
export const useUserConsents = (context) => {
    const GET_USER_CONSENTS_QUERY_KEY_BASE = "GET_USER_CONSENTS_QUERY_KEY_BASE_" + context;
    const consentsApi = new ConsentsApi();
    return useQuery({
        queryKey: [GET_USER_CONSENTS_QUERY_KEY_BASE],
        queryFn: () => consentsApi.getUserConsents(context),
        staleTime: 5000,
        retry: false,
    });
};
//# sourceMappingURL=useUserConsents.js.map